function Contact()
{
    return(
        <section id="contact">
            <h2>Contact</h2>
            <p>Email: reshmatnpillai@gmail.com</p>
            <p>Phone: +91 8754281898</p>
        </section>
    );
}export default Contact